import React, { useEffect, useState } from "react";
import commonstyles from "shared/utils/common.module.css";
import "./shareTicket.css";
import CustomLoader from "shared/components/New_Loader/Loader";
import { add_File, fetchSingleBooking } from "shared/services";
import { fetchTravel, pushTicket_To } from "shared/services/TravelAgency";
import { useLocation, useNavigate } from "react-router-dom";
import { PrimaryButton, TravelerInformation } from "shared/components";
import toast from "react-hot-toast";
import {
  notifyError,
  notifySuccess,
} from "shared/components/A_New_Components/ToastNotification";
import { RiDeleteBin6Line } from "react-icons/ri";
import { useTranslation } from "react-i18next";
import { HiOutlineDownload } from "react-icons/hi";
import { TbUpload } from "react-icons/tb";
import { useQuery } from "@tanstack/react-query";
const TravelTicketshare = () => {
  const { t, i18n }: any = useTranslation();
  const [url, setUrl] = useState<any>("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [travelers, setTraveler] = useState([]);
  const { state } = useLocation();
  console.log("🚀 ~ TravelTicketshare ~ state:", state);
  const [dataName, setName] = useState<any>("");
  const navigate = useNavigate();
  const val = state?.data;
  const onUploadImage = (event: any) => {
    setLoading(true);
    const file = event.target.files[0];
    if (file) {
      const formData = new FormData();
      formData.append("file", file);
      add_File(formData)
        .then((response: any) => {
          setName(file.name);
          setUrl(response.data.fileUrl);
        })
        .catch((err: any) => {
          console.error(err);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };
  const params = {
    bidRequestId: state?.data?.bidIds?.[0]?._id,
  };
  console.log("🚀 ~ TravelTicketshare ~ params:", params);
  const { data, isLoading, isFetching, refetch } = useQuery({
    queryKey: ["GetTravellers"],
    queryFn: () => fetchTravel(params),
    staleTime: 5 * 60 * 1000,
  });

  let GetData = data?.data;
  console.log("🚀 ~ TravelTicketshare ~ GetData:", GetData);

  useEffect(() => {
    funGetTravels();
  }, []);
  const funGetTravels = () => {
    const data = {
      bidRequestId: val?.bidIds?.[0]?._id,
    };
    fetchTravel(data)
      .then((res: any) => {
        setTraveler(res?.data?.travellers);
      })

      .catch((err: any) => {})
      .finally(() => {});
  };
  const deleteFile = () => {
    setUrl(null);
    setName(null);
  };

  const handleDownload = (file: string | Blob | null) => {
    if (file) {
      const url = typeof file === "string" ? file : URL.createObjectURL(file);

      window.open(url, "_blank");

      if (typeof file !== "string") {
        URL.revokeObjectURL(url);
      }
    } else {
      notifyError("File is not Available.");
    }
  };

  const submitFile = async () => {
    if (!url) {
      notifyError("Please upload your ticket");
      return;
    }
    setLoading(true);

    try {
      const data = {
        bidRequestId: val?.bidIds?.[0]?._id,
      };
      const params = {
        eTicket: url,
      };
      const response = await pushTicket_To(data, params);

      setLoading(false);
      notifySuccess("Your file has been submitted successfully!");
      navigate("/travelAgency/ticketRequests");
    } catch (error) {
      setLoading(false);
      console.error("Error uploading file:", error);
      toast.error(
        "There was an error submitting the file. Please try again later."
      );
    }
  };
  return (
    <div
      className={
        ["ur", "ar", "ps", "pr"].includes(i18n.language)
          ? commonstyles.pl36
          : commonstyles.pr36
      }
    >
      <p className="label">{t("travelerInformation")}</p>
      <div className="outerContainer">
        {GetData?.travellers?.map((v: any, index: number) => (
          <div
            key={index}
            className="passenger-card"
            style={{ marginBottom: "16px" }}
          >
            <p className="HeaDING">
              {t("passenger")} {index + 1} {t("details")}
            </p>

            <div className="Wrappers">
              <div className="Roww">
                <p className="Tirtle">{t("name")}:</p>
                <p className="Value">{v?.name || "N/A"}</p>
              </div>

              <div className="Roww">
                <p className="Tirtle">{t("passportNo")}:</p>
                <p className="Value">{v?.passportNo || "N/A"}</p>
              </div>

              {v?.visaFile && (
                <div
                  className="Roww clickable"
                  onClick={() => handleDownload(v.visaFile)}
                >
                  <HiOutlineDownload size={20} color="#ff7631" />
                  <p className="downloadtilte">{t("visaFile")}</p>
                </div>
              )}

              {v?.passportFile && (
                <div
                  className="Roww clickable"
                  onClick={() => handleDownload(v.passportFile)}
                >
                  <HiOutlineDownload size={20} color="#ff7631" />
                  <p className="downloadtilte">{t("passportFile")}</p>
                </div>
              )}
            </div>
          </div>
        ))}
        <div className="parentContainer">
          {!url && (
            <label className="uploadContainer">
              <div
                style={{ display: "flex", alignItems: "center", gap: "24px" }}
              >
                <TbUpload size={30} color="#ff7631" />
                <span
                  style={{
                    fontSize: "14px",
                    fontWeight: "500",
                    color: "#ff7631",
                  }}
                >
                  {t("upload")} {t("ticket")}
                </span>
              </div>

              <input
                type="file"
                style={{ display: "none" }}
                onChange={onUploadImage}
              />
            </label>
          )}
        </div>
        <div className="parentContainer">
          {url && (
            <div
              className="fileContainer"
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <span>{dataName}</span>
              <div className="deleteButton">
                <RiDeleteBin6Line onClick={deleteFile} className="deleteIcon" />
              </div>
            </div>
          )}
          {error && <p style={{ color: "red" }}>{error}</p>}
        </div>
        <div style={{ marginTop: "56px", width: "210px" }}>
          <PrimaryButton
            onClick={submitFile}
            colorType={"New_blue"}
            type={"button"}
            children={t("shareTicket")}
          ></PrimaryButton>
        </div>
      </div>

      {loading && <CustomLoader />}
    </div>
  );
};

export default TravelTicketshare;
